export default {"src":"/_next/static/media/pillWithClock_24.8c5e72f2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};